export class QuoterRequestErrorGeneral {
    startDateOutOfRange = false;
    startDateNotSet = false;
    participatingInsurerDateNeeded = false;
    renewalIsEmpty = false;
    street = false;
    enterValidZipCode = false;
    ParticipatingInsurerIsEmpty = false;
    streetIsEmpty = false;
    AddressStateIsIncorrect = false;
    city = false;
    zipCodeIsEmptyOrlengthIncorrect = false;
    zipCodeIsEmptyShowLink=false;
}

export class QuoterRequestErrorQuestion {
    YearBuiltIsEmpty = false;
    YearBuiltIsOutsideOfRange = false;
    InsuredValueIsEmpty = false;
    InsuredValueOutOfRange = false;
    InsuredValueOutOfRangeHigh = false;
    foundationTypeVariableIsNotSelected = false;
    roofTypeVariableIsNotSelected = false;
    numberOfStoriesIsNotSelected = false;
}
